// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"61":"8ff9508f","397":"90274537","517":"320d777a"}[chunkId] + ".css";
};